"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickAwayListener = void 0;
const react_1 = require("react");
const useClickAwayListener = ({ onClickAway, wrapper }) => {
    (0, react_1.useEffect)(() => {
        const handleClickAway = ({ target }) => {
            if (wrapper.current && !wrapper.current.contains(target)) {
                onClickAway();
            }
        };
        document.addEventListener('mousedown', handleClickAway);
        return () => {
            document.removeEventListener('mousedown', handleClickAway);
        };
    }, []);
};
exports.useClickAwayListener = useClickAwayListener;
//# sourceMappingURL=use-click-away-listener.js.map